import { format } from 'date-fns';
import styled from 'styled-components';

type DateRangeBadgeProps = {
  startDate: Date;
  endDate: Date;
  className?: string;
};

export default function DateRangeBadge({ startDate, endDate, className }: DateRangeBadgeProps) {
  const formattedStart = format(startDate, 'MM/dd/yyyy');
  const formattedEnd = format(endDate, 'MM/dd/yyyy');

  return (
    <Badge className={className}>
      {formattedStart} - {formattedEnd}
    </Badge>
  );
}

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.black05};
  color: ${({ theme }) => theme.colors.black};
  font-size: 10px;
  font-weight: normal;
  letter-spacing: 0.15px;
  border-radius: 2px;
  white-space: nowrap;
`;
